import React, { useRef } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
import BallastCoverPage from './BallastCoverPage';
import BallastPrint from './BallastPrint';
import { ballastSelectors } from '../../../../../redux/app/ballast';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';
import { marpolSelectors } from '../../../../../redux/app/marpol';
import { getFilteredTanks } from 'redux/app/vessel/inspector/utils';
import TankWithPositionTable from 'components/app/vessel/onboard/inspector/_elements/TankWithPositionTable';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type BallastInspectorViewProps = PropsFromRedux & OwnProps;
function BallastInspectorView(props: BallastInspectorViewProps) {
    const { historyList, showCoverPages, tanks, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    const filteredTanks = getFilteredTanks(tanks, 'type', ['BALLAST_TANK']);
    return (
        <>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? (
                <BallastCoverPage vesselId={vesselId}>
                    <div className="flex justify-center">
                        <TankWithPositionTable
                            hidePositionCol
                            tanks={filteredTanks}
                        />
                    </div>
                </BallastCoverPage>
            ) : null}
            <div className="newpage">
                <BallastPrint
                    key={'temp-print-id'}
                    isPrintVisible={true}
                    ballastRecords={historyList}
					vesselId={vesselId}
                />
            </div>
        </>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const ballastRecordStore = ballastSelectors._getStore(store);
    const historyList = ballastSelectors.getHistoryList(ballastRecordStore);
    const marpolStore = marpolSelectors._getStore(store);
    const tanks = marpolSelectors.getTanks(marpolStore);
    return {
        historyList,
        tanks,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BallastInspectorView);
